import { alpha, Box } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface ScrollableCommentTextProps {
  text: string;
}

export function ScrollableCommentText(props: ScrollableCommentTextProps) {
  const { text } = props;

  return (
    <Box
      sx={(theme) => {
        const bg = theme.palette.background.tertiary ?? theme.palette.background.paper;
        return {
          maxHeight: "20vh",
          overflow: "auto",
          "&::after": {
            content: '""',
            position: "sticky",
            bottom: 0,
            display: "block",
            height: "2rem",
            // eslint-disable-next-line cbh-rules/no-inline-gradient -- fade-to-background for scroll overflow indicator
            background: `linear-gradient(${alpha(bg, 0)}, ${bg})`,
            pointerEvents: "none",
            marginTop: "-1rem",
          },
        };
      }}
    >
      <Text semibold variant="h6">
        {text}
      </Text>
    </Box>
  );
}
